import CivilServices from "../Assets/Images/Services/civil-services.jpg";
import SolarServices from "../Assets/Images/Services/solar-services.jpg";
import LightingServices from "../Assets/Images/Services/lighting-services.jpg";
import Printing from "../Assets/Images/Services/printing.png";
import webDev from "../Assets/Images/Services/website-development.jpg";
import AISolutions from "../Assets/Images/Services/ai-solutions.jpg";
import AppSoftware from "../Assets/Images/Services/app-software.png";
import Marketing from "../Assets/Images/Services/marketing.png";
import HR from "../Assets/Images/Services/hr-services.png";
import BOS from "../Assets/Images/Services/business-operations.png";
import Financial from "../Assets/Images/Services/financial.png";
import Administration from "../Assets/Images/Services/administration.png";

// engineering solution
export const engineeringConsultancy = [
  {
    title: "Civil Services",
    icon: CivilServices,
    description:
      "We support construction and interior fit-out projects with detailed planning, estimation, and bidding support to keep your projects on time and within budget.",
    services: [
      "Interior Fit-Out Cost Estimation",
      "BOQ (Bill of Quantities) / Material Takeoff",
      "Tender Support & Bidding Solutions",
    ],
    link: "civil-services",
  },
  {
    title: "Solar Services",
    icon: SolarServices,
    description:
      "From load analysis to procurement, our solar consultants help you design, estimate, and source complete solar energy systems.",
    services: [
      "Load Audits",
      "System Design",
      "Cost Estimation & Material Takeoff",
      "Procurement Assistance",
    ],
    link: "solar-services",
  },
  {
    title: "Lighting Services",
    icon: LightingServices,
    description:
      "Enhance aesthetics and energy efficiency with our end-to-end lighting consultancy services tailored for residential, commercial, and industrial projects.",
    services: [
      "Lighting Design",
      "Cost Analysis & Material Planning",
      "Product Sourcing & Procurement",
    ],
    link: "lighting-services",
  },
];

// DIGITAL SERVICES
export const digitalServices = [
  {
    title: "Analytics & Business Intelligence",
    icon: Printing,
    description:
      "Unlock actionable insights and make smarter business decisions with our end-to-end data analytics services.",
    services: [
      "SAP Analytics",
      "Power BI & Tabular Models",
      "SAP Analytics Cloud (SAC)",
    ],
    link: "analytics",
  },
  {
    title: "Web Development",
    icon: webDev,
    description:
      "We design, build, and manage high-performance websites that support your brand and business goals.",
    services: [
      "CMS Platforms",
      "Custom & Basic Website Development",
      "AI Integrations & Automation",
      "Full Website Management",
    ],
    link: "web-development",
  },
  {
    title: "AI Solutions",
    icon: AISolutions,
    description:
      "Modernize your business with intelligent software solutions built to enhance productivity, engagement, and automation.",
    services: [
      "Custom Software Development",
      "AI-Powered Website Features",
      "Chatbot Integration for eCommerce",
    ],
    link: "ai-solutions",
  },
  {
    title: "App & Software",
    icon: AppSoftware,
    description:
      "Build smarter systems with tailored software solutions that simplify workflows, boost efficiency, and improve user experience.",
    services: [
      "Custom Software Development",
      "Smart Website Features",
      "Chat Support Integration",
    ],
    link: "app-&-software",
  },
  {
    title: "Marketing",
    icon: Marketing,
    description:
      "Promote your brand with data-driven marketing strategies that drive traffic, generate leads, and grow your online presence.",
    services: [
      "Social Media Marketing",
      "Search Engine Optimization",
      "Google Ads Management",
    ],
    link: "marketing",
  },
];

// DEDICATED RESOURCES
export const dedicatedResourcesServices = [
  {
    title: "HR & Administrative Services",
    icon: HR,
    description:
      "We provide qualified professionals to support core business functions, so you can stay focused on growth.",
    services: [
      "Sales & Marketing Support",
      "Accounting & Finance",
      "Cold Calling & Lead Outreach",
      "Engineering Support Staff",
    ],
    link: "hr-services",
  },
  {
    title: "Business Operations Support",
    icon: BOS,
    description:
      "Streamline your day-to-day business processes with experienced operational staff who work as an extension of your team.",
    services: [
      "Logistics Coordination",
      "Inventory Management",
      "E-commerce Store Management",
      "Website Management",
    ],
    link: "business-operations",
  },
  {
    title: "Financial Services",
    icon: Financial,
    description:
      "Manage your business finances with expert support in bookkeeping, reporting, and financial planning — all in one place.",
    services: [
      "Bookkeeping & Accounting",
      "Budgeting & Forecasting",
      "Financial Reporting",
    ],
    link: "financial-services",
  },
  {
    title: "Administrative Services",
    icon: Administration,
    description:
      "Stay focused on growth while we handle your daily operations — from virtual assistance to document management and coordination.",
    services: [
      "Virtual Assistance",
      "Data Entry & Document Handling",
      "Task & Team Coordination",
    ],
    link: "administrative-services",
  },
];
